import React from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

import PhoneIcon from '../../../../assets/icons/contactIcons/PhoneIcon';
import EmailIcon from '../../../../assets/icons/contactIcons/EmailIcon';
import ActionButton from '../../../components/ActionButton/ActionButton';
import {
  AvatarIconWrapper,
  AvatarImage,
  AvatarPlaceholder,
  CardContainer,
  EmailText,
  InfoContainer,
  Name,
  Title,
} from './styles';
import { ConsultantCardInfoProps } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import MobileIcon from '../../../../assets/icons/contactIcons/MobileIcon';

const ConsultantCardInfo: React.FC<ConsultantCardInfoProps> = ({
  displayName,
  description,
  phone,
  mobile,
  email,
  image,
  onPhoneClick = () => {},
  onEmailClick = () => {},
}) => {
  const { t } = useI18n();

  return (
    <CardContainer>
      {image ? (
        <AvatarImage
          src={`data:image/jpeg;base64,${image}`}
          alt={displayName}
        />
      ) : (
        <AvatarPlaceholder>
          <AvatarIconWrapper>
            <PersonOutlineIcon />
          </AvatarIconWrapper>
        </AvatarPlaceholder>
      )}
      {displayName && <Name>{displayName}</Name>}
      {description && <Title>{description}</Title>}
      <InfoContainer>
        {phone && (
          <ActionButton
            variant="interaction-button"
            buttonText={phone}
            icon={<PhoneIcon />}
            onClickAction={onPhoneClick.bind(this, phone)}
          />
        )}
        {mobile && (
          <ActionButton
            variant="interaction-button"
            buttonText={mobile}
            icon={<MobileIcon />}
            onClickAction={onPhoneClick.bind(this, mobile)}
          />
        )}
        {email && (
          <ActionButton
            variant="interaction-button"
            buttonText={
              <EmailText>{t(TranslationKeys.my_contacts_send_email)}</EmailText>
            }
            icon={<EmailIcon />}
            onClickAction={onEmailClick.bind(this, email)}
          />
        )}
      </InfoContainer>
    </CardContainer>
  );
};

export default ConsultantCardInfo;
